import { render } from "./DuzenleDiyetTanim.vue?vue&type=template&id=68ddd5ba"
import script from "./DuzenleDiyetTanim.vue?vue&type=script&lang=js"
export * from "./DuzenleDiyetTanim.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\cosku\\OneDrive\\Masaüstü\\DiyetisyenYagmurDemir\\GT Yönetim Sistemi - Kopya\\Yönetim Sistemi - Frontend\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__